import angular from 'angular';
import '../../common/localizationMapService';

const mapsServices = angular.module('applicationModule.mapsServices', []);

mapsServices.factory('Map', ['MapAPI', function (MapAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return MapAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (pointId, appId) {
            return MapAPI.getPoint(pointId, appId);
        },
        save: function (point, editMode) {
            if (editMode) {
                return MapAPI.edit(point);
            } else {
                return MapAPI.create(point);
            }
        },
        remove: function (pointId) {
            return MapAPI.remove(pointId);
        },
        tags: function (appId, text) {
            return MapAPI.getTags(appId, text);
        }
    };
}]);


mapsServices.service('MapAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/map/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getPoint = function (pointId, appId) {
        return $http.get(API_URL + pointId, {params: {application_id: appId}});
    };

    this.edit = function (point) {
        return $http.put(API_URL + point.id, point);
    };

    this.create = function (point) {
        return $http.post(API_URL, point);
    };

    this.remove = function (pointId) {
        return $http.delete(API_URL + pointId);
    };

    this.getTags = function (appId, text) {
        return $http.get(API_URL + 'tags/' + appId, {params: {search: text}});
    };
}]);

export default mapsServices;
